import { useId } from "react";
import { Input, type InputProps } from "./Input";
import { cn } from "@repo/shared/utils";

export interface RadioInputProps extends Omit<InputProps, "id"> {
  id?: string;
  onCheckedChange?: (checked: boolean) => void;
}

export const RadioInput = ({
  id,
  className,
  onChange,
  onCheckedChange,
  ...props
}: RadioInputProps) => {
  const defaultId = useId();
  id ??= defaultId;

  return (
    <Input
      id={id}
      className={cn("w-5 h-5 border-black bg-white", className)}
      type="radio"
      onChange={(evt) => {
        onChange?.(evt);
        onCheckedChange?.(evt.target.checked);
      }}
      {...props}
    />
  );
};
